import { Component, OnInit } from '@angular/core';
import { DepartmentService } from '../../service/department/department.service';
import { Department } from '../../class/department';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss']
})
export class DepartmentsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public departments: Department[];
    public selectDepartment: Department;
    public departmentID: Number = 0;
    public modNew = false;
    public modView = false;
    public openDepartment = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public departmentService: DepartmentService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        //this.getDepartments();
        this.page = 1;
        this.per_page = 100;
    }

    public loadDepartmentsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getDepartments(event.globalFilter);
    }

    public getDepartments(query?: string) {
        this.departmentService.getDepartment(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.departments = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newDepartment() {
        this.modNew = !this.modNew;
        this.selectDepartment = null;
    }

    public savedDepartment(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectDepartment = null;
        this.modNew = false;
        this.getDepartments();
    }

    public cancelDepartment (res) {
        this.selectDepartment = null;
        this.modNew = false;
        this.modView = false;
        this.getDepartments();
    }

    public edit(department: Department) {
        this.modNew = true;
        this.selectDepartment = department;
        this.getDepartments();
    }

    public view(department: Department) {
        this.openDepartment = true;
        this.selectDepartment = department;
        this.departmentID = department.id;
        this.modView = true;
    }

    public deleteDialog(department: Department) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(department);
            }
        });
    }

    public delete(department: Department) {
        this.departmentService.deleteDepartment(department.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getDepartments();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeDepartment(department: Department) {
        this.putDepartment(department);
    }

    public putDepartment(values: Department) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.departmentService.updateDepartment(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/departments/departments.component.ts